import classes from './ProjectCard.module.scss'

import { motion } from 'framer-motion'

import { Image } from '../images/Image'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

const ProjectCard = ({
  app_url,
  title,
  img,
  blur_hash,
  body,
  languages,
  code_url,
}) => {
  return (
    <motion.article
      className={classes.project_card}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.25, ease: 'easeOut' }}
    >
      <div className={classes.project_card_image_wrapper}>
        <a
          href={app_url}
          aria-label={`View live ${title}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            src={`/images/${img}`}
            alt={title}
            blur={blur_hash}
            aspectRatio={[380, 220]}
          />
        </a>
      </div>
      <div className={classes.project_card_content_wrapper}>
        <a
          href={app_url}
          aria-label={`View live ${title}`}
          target="_blank"
          rel="noopener noreferrer"
          className="plain-link"
        >
          <h2 className={classes.project_card_content_wrapper_title}>
            {title}
          </h2>
        </a>
        <p className={classes.project_card_content_wrapper_tech}>
          {languages.join(' / ').toUpperCase()}
        </p>
        <p className={classes.project_card_content_wrapper_body}>{body}</p>
        <div className={classes.project_card_content_wrapper_footer}>
          <a
            href={code_url}
            aria-label={`View ${title}´s code`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faGithub} aria-hidden="true" />
          </a>
          <a
            href={app_url}
            aria-label={`View live ${title}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
          </a>
        </div>
      </div>
    </motion.article>
  )
}
export default ProjectCard
